<script>
import GraficosCustom from '@/components/analytics/GraficosCustom.vue'
import moment from 'moment'

export default {
  name: 'PersonPlayVideo',
  components: { GraficosCustom },
  props: ['value', 'srcVideo', 'posterVideo', 'idMuted', 'autoplayVideo', 'analise', 'timeds'],
  data() {
    return {
      currentTime: 0,
      xAxisData: [],
      series: [],
    }
  },
  computed: {
    getAxisData() {
      if (this.timedsVideos != null) {
        return this.timedsVideos.map(t => this.segParaHora(parseInt(t.timed)).substring(3))
      }
      return []
    },
    getSeriesData() {
      if (this.timedsVideos != null) {
        return this.timedsVideos.map(t => t.total)
      }
      return []
    },
    optionsChart() {
      return {
        xAxis: this.getAxisData,
        series: this.getSeriesData,
      }
    },
    video() {
      return this.$refs.myVideo
    },
    vlsVideo: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    timedsVideos() {
      return this.timeds
    },
    analiseComputed: {
      get() {
        return this.analise
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    timeds(newValue, oldValue) {
      if ([undefined, null, ''].indexOf(newValue) === -1 && [undefined, null, ''].indexOf(this.getSeriesData) === -1 && [undefined, null, ''].indexOf(this.getAxisData) === -1) {
        this.$refs.graficoCustom.updatedChart(this.getSeriesData, this.getAxisData)
      }
    },
  },
  mounted() {
    this.video.src = this.srcVideo
    if (this.timedsVideos != null) {
      this.timedsVideos.forEach(t => {
        this.xAxisData.push(this.segParaHora(parseInt(t.timed)).substring(3))
        this.series(t.total)
      })
    }
  },
  methods: {
    atualizar(e) {
      const time = moment(e.name, 'mm:ss')
      const timeInSeconds = (time.minutes() *60) + time.second()
      this.video.currentTime = timeInSeconds
    },
    segParaHora(time, with_seg = true) {
      let hours = Math.floor(time / 3600)
      let minutes = Math.floor((time % 3600) / 60)
      let seconds = time % 60

      minutes = minutes < 10 ? `0${minutes}` : minutes
      seconds = seconds < 10 ? `0${seconds}` : seconds
      hours = hours < 10 ? `0${hours}` : hours

      if (with_seg) {
        return `${hours}:${minutes}:${seconds}`
      }

      return `${hours}:${minutes}`
    },
    getClickDataChart(e) {
      const time = moment(e.name, 'mm:ss')
      const timeInSeconds = (time.minutes() * 60) + time.second()
      this.video.currentTime = timeInSeconds
    },
  },
}
</script>

<template>

  <div class="container player">
    <div
      v-if="$route.name === 'analytics'"
      class="ajuste-chart"
    >
      <GraficosCustom
        ref="graficoCustom"
        @mousemove="atualizar($event)"
        :data-chart="optionsChart.xAxis"
        :label-chart="optionsChart.series"
        @click="getClickDataChart"
      />
    </div>
    <video
      ref="myVideo"
      class="player_my_video viewer"
      :src="srcVideo"
      type="video/mp4"
      :autoplay="autoplayVideo"
      :controls="$route.name !== 'analytics'"
      :muted="idMuted"
      @click="atualizar($event)"
      :poster="posterVideo"
    >
      <slot name="message-nosuported" />
    </video>

  </div>
</template>

<style scoped>
.player {
  height: 100%;
}

.ajuste-chart {
  position: absolute;
  z-index: 10 !important;
  width: 102.9%;
}

.player_my_video {
  width: 100%;
  height: 600px;
  background: black;
}
</style>
